import React from 'react'
import {Spin} from 'antd'
import {LoadingOutlined} from '@ant-design/icons'

const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;

function FullPageSpinner() {
    return (
        <div style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0}}>
            <Spin indicator={antIcon}/>
        </div>
    )
}

export default FullPageSpinner
